import { Routes, Route } from "react-router-dom";

import Layout from "../components/Layout";

import Home from "../pages/Home";

import LeaveApply from "../pages/leave/LeaveApply";

import LeaveBalance from "../pages/leave/LeaveBalance";

import LeaveCalendar from "../pages/leave/LeaveCalendar";

import Profile from "../pages/Profile";

import ProtectedRoute from "./ProtectedRoute";

import PendingTab from "../pages/leave/components/PendingTab";

import HistoryTab from "../pages/leave/components/HistoryTab";

import ReviewLeave from "../pages/manager/ReviewLeave";

import ManagerReviewLeave from "../pages/manager/ManagerLeaveReview"

import LeaveDetails from "../pages/manager/LeaveDetails";

import ProtectedManagerRoute from "./ProtectedManagerRoute";
import ProtectedHrRoute from "./ProtectedHrRoute";
import LeaveDashboard from "../pages/manager/LeaveDashboard";

import EmployeeMonthlySummary from "../pages/manager/EmployeeMonthlySummary";
import TransactionHistory from "../pages/manager/TransactionHistory";
import LeaveBalancesHr from "../pages/hr/LeaveBalances";
import LeaveTransactionsHr from "../pages/hr/LeaveTransactions";

import Login from "../pages/auth/Login";

import Signup from "../pages/auth/Signup";
import ActivityLogs from "../pages/hr/ActivityLogs";
import HrUsers from "../pages/hr/HrUsers";

// ======================================================
// ROUTES
// ======================================================

export default function AppRoutes() {

  return (

    <Routes>

      {/* ================================================= */}
      {/* AUTH ROUTES */}
      {/* ================================================= */}

      <Route
        path="/"
        element={<Login />}
      />

      <Route
        path="/login"
        element={<Login />}
      />

      <Route
        path="/signup"
        element={<Signup />}
      />

      {/* ================================================= */}
      {/* HOME */}
      {/* ================================================= */}

      <Route
        path="/home"

        element={
          <ProtectedRoute>

            <LayoutWrapper>

              <Home />

            </LayoutWrapper>

          </ProtectedRoute>
        }
      />

      {/* ================================================= */}
      {/* LEAVE APPLY */}
      {/* ================================================= */}

      <Route
        path="/leave/apply"

        element={
          <ProtectedRoute>

            <LayoutWrapper>

              <LeaveApply />

            </LayoutWrapper>

          </ProtectedRoute>
        }
      />

      {/* ================================================= */}
      {/* LEAVE BALANCE */}
      {/* ================================================= */}

      <Route
        path="/leave/balance"

        element={
          <ProtectedRoute>

            <LayoutWrapper>

              <LeaveBalance />

            </LayoutWrapper>

          </ProtectedRoute>
        }
      />

      {/* ================================================= */}
      {/* LEAVE CALENDAR */}
      {/* ================================================= */}

      <Route
        path="/leave/calendar"

        element={
          <ProtectedRoute>

            <LayoutWrapper>

              <LeaveCalendar />

            </LayoutWrapper>

          </ProtectedRoute>
        }
      />

      {/* ================================================= */}
      {/* PENDING TAB */}
      {/* ================================================= */}

      <Route
        path="/leave/pending-tab"

        element={
          <ProtectedRoute>

            <LayoutWrapper>

              <PendingTab />

            </LayoutWrapper>

          </ProtectedRoute>
        }
      />

      {/* ================================================= */}
      {/* HISTORY TAB */}
      {/* ================================================= */}

      <Route
        path="/leave/history-tab"

        element={
          <ProtectedRoute>

            <LayoutWrapper>

              <HistoryTab />

            </LayoutWrapper>

          </ProtectedRoute>
        }
      />

      {/* ================================================= */}
      {/* PROFILE */}
      {/* ================================================= */}

      <Route
        path="/profile"

        element={
          <ProtectedRoute>

            <LayoutWrapper>

              <Profile />

            </LayoutWrapper>

          </ProtectedRoute>
        }
      />

      {/* ================================================= */}
      {/* MANAGER REVIEW */}
      {/* ================================================= */}

      <Route
        path="/manager/review"

        element={
          <ProtectedManagerRoute>

            <LayoutWrapper>

              <ReviewLeave />

            </LayoutWrapper>

          </ProtectedManagerRoute>
        }
      />
<Route
        path="/manager/review_new"

        element={
          <ProtectedManagerRoute>

            <LayoutWrapper>

              <ManagerReviewLeave />

            </LayoutWrapper>

          </ProtectedManagerRoute>
        }
      />
      {/* ================================================= */}
      {/* LEAVE DASHBOARD */}
      {/* ================================================= */}

      <Route
        path="/manager/dashboard"

        element={
          <ProtectedManagerRoute>

            <LayoutWrapper>

              <LeaveDashboard />

            </LayoutWrapper>

          </ProtectedManagerRoute>
        }
      />

      {/* ================================================= */}
      {/* EMPLOYEE MONTHLY SUMMARY */}
      {/* ================================================= */}

      <Route
        path="/manager/monthly-summary"

        element={
          <ProtectedManagerRoute>

            <LayoutWrapper>

              <EmployeeMonthlySummary />

            </LayoutWrapper>

          </ProtectedManagerRoute>
        }
      />

      {/* ================================================= */}
      {/* TRANSACTION HISTORY */}
      {/* ================================================= */}

      <Route
        path="/manager/transactions"

        element={
          <ProtectedManagerRoute>

            <LayoutWrapper>

              <TransactionHistory />

            </LayoutWrapper>

          </ProtectedManagerRoute>
        }
      />

      {/* ================================================= */}
      {/* HR LEAVE ADMIN */}
      {/* ================================================= */}

      <Route
        path="/hr/balances"
        element={
          <ProtectedHrRoute>
            <LayoutWrapper>
              <LeaveBalancesHr />
            </LayoutWrapper>
          </ProtectedHrRoute>
        }
      />

      <Route
        path="/hr/transactions"
        element={
          <ProtectedHrRoute>
            <LayoutWrapper>
              <LeaveTransactionsHr />
            </LayoutWrapper>
          </ProtectedHrRoute>
        }
      />

      {/* ================================================= */}
      {/* LEAVE DETAILS */}
      {/* ================================================= */}

      <Route
        path="/manager/review/:id"

        element={
          <ProtectedManagerRoute>

            <LayoutWrapper>

              <LeaveDetails />

            </LayoutWrapper>

          </ProtectedManagerRoute>
        }
      />
      <Route
  path="/hr/activity-logs"
  element={
    <ProtectedHrRoute>
      <LayoutWrapper>
        <ActivityLogs />
      </LayoutWrapper>
    </ProtectedHrRoute>
  }
/>
<Route
  path="/hr/users"
  element={
    <ProtectedHrRoute superAdminOnly>
      <LayoutWrapper>
        <HrUsers />
      </LayoutWrapper>
    </ProtectedHrRoute>
  }
/>

    </Routes>
    
  );
}

// ======================================================
// LAYOUT WRAPPER
// ======================================================

function LayoutWrapper({

  children,

}) {

  return (

    <Layout>

      {children}

    </Layout>
  );
}